import styled from "styled-components";

export const Wrapper = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  background-color: #fff;
  height: 57px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 999;
  overflow: hidden;

  @media (max-width: 600px) {
    padding: 0 20px;
  }

  .header-inner {
    position: relative;
    z-index: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &.header--loading .header-inner {
    filter: blur(2px);
    pointer-events: none;
  }

  .header-loading-overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(0.8px);
    background: rgba(255, 255, 255, 0.35);
  }

  .row-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: auto;
    gap: 20px;
    direction: rtl;
  }

  .icon {
    width: 25px;
    height: 25px;
    cursor: pointer;
    color: #201e67;
  }

  .logo {
    width: 106px;
    height: 40px;
  }

  .desktop-menu {
    @media (max-width: 1250px) {
      display: none !important;
    }
  }

  .menu-icon {
    cursor: pointer;
    margin-top: 8px;
    @media (min-width: 1251px) {
      display: none !important;
    }
  }

  .menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    height: 57px;
    gap: 35px;

    .item {
      color: #61788e;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      padding: 0 12px;
    }

    .active-route {
      color: #29bcab;
      border-bottom: 3px solid #29bcab;
      padding-bottom: 12px;
      margin-bottom: -16px;
    }
  }

  .buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    @media (max-width: 1250px) {
      display: none !important;
    }

    .button {
      cursor: pointer;
      height: 40px;
      width: 160px;
      border-radius: 8px;
      font-size: 15px;
      font-weight: 700;
      line-height: 40px;
      text-align: center;
    }

    .doctors-button {
      color: white;
      border: 1px solid #201e67;
      background: #201e67;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding: 0 13px;
    }

    .patients-button {
      color: #29bcab;
      border: 1px solid #29bcab;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding: 0 13px;
      direction: ltr;
    }
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  direction: ${(p) => p.webConfig.dir};

  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
  }

  .row-flex {
    flex-direction: row;
    gap: 2%;
  }

  .menu {
    align-items: flex-start;
    justify-content: flex-start;
    gap: 25px;
  }

  .button {
    height: 50px;
    width: 49%;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }

  .doctors-button {
    color: white;
    border: 1px solid #201e67;
    background: #201e67;
  }

  .patients-button {
    color: #29bcab;
    border: 1px solid #29bcab;
  }

  .item {
    color: #61788e;
    font-size: 15px;
    font-weight: 500;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 7px;
  }

  .active-item {
    color: #29bcab;
  }

  .width-100 {
    width: 100%;
  }
`;
